module.exports = __webpack_public_path__ + "assets/img/careai-logo.e051fdd6.svg";